module.exports = __webpack_public_path__ + "static/media/MaisonNeue-Demi.cb649b6f.woff";